// O'ng tugma menyulari, ru
export default {
  open: "Открыть",
  openNewTab: "Открыть в новой вкладке",
  copyLink: "Копировать ссылку",
  copyPhone: "Копировать телефон",
  copyEmail: "Копировать email",
  copyUsername: "Копировать логин",
  openProfile: "Открыть профиль",
  openPersonProfile: "Открыть профиль: {{name}}",
  openDriver: "Открыть водителя: {{name}}",
  copyName: "Копировать имя",
  call: "Позвонить",
  sendEmail: "Написать email",
  copied: "Скопировано",
  copyFailed: "Не удалось скопировать",
  edit: "Редактировать",
  archive: "В архив",
  setStatus: "Сменить статус",
  archiveTitle: "Отправить {{name}} в архив?",
  archivedToast: "{{name}} в архиве",
  statusChanged: "{{name}} → {{status}}",
  conflict: "Кто-то только что изменил эту запись. Список обновлён — попробуйте ещё раз.",
  failed: "Действие не выполнено",
  placement: {
    addPayment: "Записать оплату…",
    edit: "Условия оплаты…",
    writeOff: "Отметить неоплату",
    reopen: "Открыть снова",
    payments: "Поступления",
    voidPayment: "Отменить оплату",
    awaitingApproval: "Ждёт одобрения найма",
  },
  driver: {
    logCall: "Записать звонок",
    addNote: "Добавить заметку",
    addReminder: "Добавить напоминание",
    documents: "Документы",
    changeStatus: "Сменить статус",
    moveTo: "Переместить",
    markLost: "Отметить как потерянного…",
    transfer: "Передать другому…",
    openJob: "Открыть вакансию: {{title}}",
    openCarrier: "Открыть перевозчика: {{name}}",
    archiveTitle: "Отправить {{name}} в архив?",
    archiveDesc: "Водитель исчезнет из списков, воронки и отчётов. История останется в журнале аудита.",
    archived: "{{name}} в архиве",
  },
  activity: {
    title: "Записать активность · {{name}}",
    type: "Тип",
    types: { call: "Звонок", note: "Заметка", sms: "SMS", email: "Email" },
    outcome: "Результат",
    minutes: "Минуты",
    body: "Заметка",
    placeholderCall: "О чём говорили?",
    placeholderNote: "Напишите заметку…",
    bodyRequired: "Напишите текст заметки.",
    saved: "Записано в активность водителя",
  },
  transfer: {
    title: "Передать: {{name}}",
    to: "Новый владелец",
    pool: "Пул филиала (без владельца)",
    note: "Комментарий для нового владельца",
    current: "Сейчас: {{name}}",
    nobody: "никто",
    submit: "Передать",
    done: "{{name}} → {{to}}",
    chooseUser: "Выберите, кому передать водителя.",
  },
  task: {
    markDone: "Отметить выполненной",
    snooze: "Отложить",
    reopen: "Вернуть в работу",
    addFollowUp: "Добавить следующее напоминание",
    copyNote: "Копировать заметку",
  },
  approval: {
    approve: "Одобрить…",
    reject: "Отклонить…",
    openBudget: "Открыть в бюджете",
    copySummary: "Копировать описание",
  },
  notification: {
    markRead: "Отметить прочитанным",
    markUnread: "Отметить непрочитанным",
    markAllRead: "Отметить все прочитанными",
    copyText: "Копировать текст",
  },
  truck: {
    openDriver: "Открыть водителя: {{name}}",
    copyVin: "Скопировать VIN",
    copyPlate: "Скопировать номер",
  },
  carrier: {
    copyMc: "Копировать MC номер ({{mc}})",
    showJobs_one: "Показать вакансии ({{count}} открыта)",
    showJobs_few: "Показать вакансии ({{count}} открыто)",
    showJobs_many: "Показать вакансии ({{count}} открыто)",
    showJobs_other: "Показать вакансии ({{count}} открыто)",
    newJob: "Новая вакансия для перевозчика…",
    archiveDesc: "Перевозчик и его вакансии исчезнут из списков. Отправленные водители и история сохранятся.",
  },
  job: {
    submitDriver: "Отправить водителя…",
    openCarrier: "Открыть перевозчика: {{name}}",
    archiveDesc: "Вакансия исчезнет из списков, на неё больше нельзя отправлять водителей. Заявки останутся в истории водителей.",
  },
  user: {
    showDrivers_one: "Показать {{count}} водителя",
    showDrivers_few: "Показать {{count}} водителей",
    showDrivers_many: "Показать {{count}} водителей",
    showDrivers_other: "Показать {{count}} водителей",
    setPassword: "Выдать новый пароль…",
    reset2fa: "Сбросить 2FA",
    reset2faTitle: "Сбросить 2FA для {{name}}?",
    reset2faDesc: "Текущий аутентификатор перестанет работать. Если для роли 2FA обязательна, при следующем входе её нужно будет настроить заново.",
    block: "Заблокировать…",
    unblock: "Разблокировать",
    access: "Права доступа…",
  },
  branch: {
    openDashboard: "Открыть дашборд филиала",
    openBudget: "Открыть бюджет филиала",
    showUsers_one: "Показать сотрудников ({{count}} рекрутер)",
    showUsers_few: "Показать сотрудников ({{count}} рекрутера)",
    showUsers_many: "Показать сотрудников ({{count}} рекрутеров)",
    showUsers_other: "Показать сотрудников ({{count}} рекрутера)",
    openReport: "Открыть отчёт филиала",
    people: "Показать сотрудников",
  },
  budget: {
    reviewInApprovals: "Рассмотреть в согласованиях",
    openReceipt: "Открыть чек",
    payExpense: "Оплатить со счёта",
    copyAmount: "Копировать сумму",
    copyDescription: "Копировать описание",
    markPaid: "Отметить оплаченным",
    markUnpaid: "Отметить неоплаченным",
    showDetails: "Показать расчёт",
    hideDetails: "Скрыть расчёт",
    adjust: "Скорректировать…",
    approveBonus: "Одобрить этот бонус",
  },
  audit: {
    showDetails: "Показать подробности",
    openObject: "Открыть: {{name}}",
    filterActor: "Только действия: {{name}}",
    filterModel: "Только этот тип объектов",
    copyDetails: "Копировать подробности (JSON)",
    copyRequestId: "Копировать ID запроса",
  },
  import: {
    continue: "Продолжить импорт",
    openResult: "Открыть результат",
    openSheet: "Открыть таблицу в Google",
    copySheetLink: "Копировать ссылку на таблицу",
  },
  recruiter: {
    showDrivers: "Показать водителей: {{name}}",
    openReport: "Открыть в отчётах",
    focus: "Показать только: {{name}}",
  },
  report: {
    sourceDrivers: "Показать водителей из источника {{source}}",
    carrierJobs: "Показать вакансии перевозчика",
  },
  portal: {
    details: "Открыть подробности",
    accept: "Принять…",
    reject: "Отклонить…",
    copyTitle: "Копировать название вакансии",
    copyPay: "Копировать оплату",
  },
  application: {
    copyReply: "Копировать ответ перевозчика",
  },
  activityItem: {
    copyText: "Копировать текст",
  },
};
